import { z } from 'zod'

/**
 * Whether a message reached a mail provider, or only reached the log.
 *
 * Mirrors the Prisma enum of the same name. The distinction is the point:
 * with no provider configured the app logs a message rather than dropping it
 * silently, and calling that outcome "sent" is precisely how a non-delivery
 * passes for a delivery. Anything showing a delivery has to be able to say
 * which of the two happened.
 */
export const MAIL_DISPOSITIONS = ['SENT', 'LOGGED'] as const

export const mailDispositionSchema = z.enum(MAIL_DISPOSITIONS)

export type MailDisposition = z.infer<typeof mailDispositionSchema>
